import React, { useEffect, useState,useContext  } from "react";
import "./App.css";
//import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import { AuthProvider,useAuth} from "./authContext/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
// import { toggleTheme } from "./redux/theme"; // Adjust the import path if needed
import Routespage from "../src/components/routes/Routespage";
import { Router } from "react-router-dom";
import BreadCrumb from "./components/BreadCrumb/BreadCrumb";
import ComponentsWrapper from "./components/ComponentsWrapper/ComponentsWrapper";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchCodebookData } from "./components/CodeBook/redux/CodeBookSlicer"; // Adjust the path
import DashboardLayout from "./components/Layout/DashboardLayout";
import ErrorModalPopup from "./ErrorModalPopup";
import ContextWrapper from "./context";
import ServiceWorkerHandler from "./components/ServiceWorkerHandler";
import { SidebarProvider } from "./components/Layout/SiderbarContext";

function App() {
  const [isModalVisible, setIsmodal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  useEffect(() => {
    const handleSessionExpired = (event) => {
      const errorMessage = event.detail.errorMessage;
      setModalMessage(errorMessage);
      setIsmodal(true);
    };
    window.addEventListener("tokenExpired", handleSessionExpired);
    return () => {
      window.removeEventListener("tokenExpired", handleSessionExpired);
  
    };
  }, []);
//   useEffect(() => {
//     const handleTabClose = () => {
//  const url = "https://ap-southeast-2qaj4mzg1x.auth.ap-southeast-2.amazoncognito.com/logout?client_id=2412c4nvn033h8eonph7e5lhfc&logout_uri=https%3A%2F%2Fdev-test.pallas-ai.com.au%2F"
//       const payload = {
//         event: "tab_closed",
//         timestamp: Date.now(),
//       };

//       // Convert data to a blob for sendBeacon
//       const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });

//       navigator.sendBeacon(url, blob);
//     };

//     // `unload` is fired when tab or window is closed
//     window.addEventListener("unload", handleTabClose);

//     // cleanup listener on unmount
//     return () => window.removeEventListener("unload", handleTabClose);
//   }, []);
  
  const handleClose = () => {
    sessionStorage.clear();
    setIsmodal(false);
    window.location.replace("/login");
  };
  return (
    <>
    <ServiceWorkerHandler/>
    <ContextWrapper>
      <AuthProvider>
        <SidebarProvider>
      <MainApp />
      </SidebarProvider>  
    </AuthProvider>
    </ContextWrapper>
    <ErrorModalPopup
      show={isModalVisible}
      setShow={setIsmodal}
      handleModalClose={handleClose}
      message={modalMessage}
    />
    </>
  
  );
}

function MainApp() {
  const { isAuthenticated } = useAuth();
  const [isRowClicked, setIsRowClicked] = useState(false);
  return (
    <>
    
      <ToastContainer position="top-center" autoClose={3000} />
      {isAuthenticated ? (
        <DashboardLayout>
          <Routespage isRowClicked={isRowClicked} setIsRowClicked={setIsRowClicked} />
        </DashboardLayout>
      ) : (
        <Routespage isRowClicked={isRowClicked} setIsRowClicked={setIsRowClicked}/>
      )}
    </>
  );
}

export default App;